module.exports = __webpack_public_path__ + "img/lxwmbj.3f636581.png";